import { HealthRecordApiInterface } from "@syadem/kairos-citizen-js";
import { ActionResult } from "../../actionResult";
import { TravelRecord } from "../../domain/travel";
import { fromApiTravel } from "../../network/apis/travelMapper";
import { Service } from "../service";

interface Payload {
  healthRecordId: string;
}

export class ListTravelsService implements Service<Payload, TravelRecord[]> {
  constructor(private readonly healthRecordApi: HealthRecordApiInterface) {}

  async call({ healthRecordId }: Payload): Promise<ActionResult<TravelRecord[]>> {
    const { healthRecord } = await this.healthRecordApi.showHealthRecord(healthRecordId);

    return {
      type: "success",
      value: healthRecord.travels.map(fromApiTravel),
    };
  }
}
